<div class="margin--bottom-l table-width">
  <table [dataSource]="regulations()" mat-table>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Navn</th>
      <td mat-cell *matCellDef="let regulation">{{ regulation.name }}</td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let regulation">{{ regulation.type | translatePriceRegulationType }}</td>
    </ng-container>

    <ng-container matColumnDef="regulation">
      <th mat-header-cell *matHeaderCellDef>
        <div class="regulation-header">
          <span class="regulation-header__title">
            Regulering
            <span
              class="regulation-header__info-icon"
              matTooltip="Krone-værdien som afhængig af typen enten er en direkte rabat på total pris eller en fast regulering af tillæg"
              matTooltipPosition="below">
              <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
            </span>
          </span>
          <span class="header-column-template__sub-title">Ekskl. moms</span>
        </div>
      </th>
      <td mat-cell *matCellDef="let regulation" class="regulation-cell">
        @if (regulation.type === PriceRegulationType.Discount && regulation.discountAmountInKrWithoutVat !== null) {
          {{ regulation.discountAmountInKrWithoutVat | dkCurrency }}
        }
        @if (regulation.type === PriceRegulationType.SupplementOverride) {
          <div
            class="row-regulation"
            [matTooltip]="
              'Samlet tillæg: ' +
              ((regulation.okSupplementOverrideInKrWithoutVat ?? 0) + (regulation.organizationSupplementOverrideInKrWithoutVat ?? 0)
                | dkCurrency)
            "
            matTooltipPosition="below">
            @if (regulation.okSupplementOverrideInKrWithoutVat !== null && regulation.okSupplementOverrideInKrWithoutVat !== undefined) {
              <div>OK-tillæg: {{ regulation.okSupplementOverrideInKrWithoutVat | dkCurrency }}</div>
            }
            @if (
              regulation.organizationSupplementOverrideInKrWithoutVat !== null &&
              regulation.organizationSupplementOverrideInKrWithoutVat !== undefined
            ) {
              <div>Kundetillæg: {{ regulation.organizationSupplementOverrideInKrWithoutVat | dkCurrency }}</div>
            }
          </div>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let regulation" class="actions-cell">
        <div class="actions-cell__wrapper">
          <button mat-icon-button title="Rediger prisregulering" (click)="editRegulation.emit(regulation)">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
          </button>
          <button mat-icon-button class="delete" title="Slet prisregulering" (click)="deleteRegulation.emit(regulation)">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let regulation; columns: displayColumns"></tr>
  </table>
</div>
